import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";

const Card = ({data}) => {
  const {alert_name, alert_type, alert_level, inventory = {}} = data;
  const {name = "", serial = "", site_name = "", location_name = ""} = inventory;
  return (
    <CardBody>
      <CardTitle tag="h4">
        Alert Name: <CardText>{alert_name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Alert Type: <CardText>{alert_type}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Alert Level: <CardText>{alert_level}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Name: <CardText>{name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Serial: <CardText>{serial}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Site: <CardText>{site_name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Location: <CardText>{location_name}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

export default Card;
